/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { useCallback, useLayoutEffect, useState, type RefObject } from 'react';

const isWindow = (target: HTMLElement | Window): target is Window => target === window;

type ScrollDirection = 'up' | 'down' | 'none';

interface ScrollState {
  x: number;
  y: number;
  direction: ScrollDirection;
}

/** Tracks scroll position/direction and provides scroll helpers for either the window or a specific element. */
export const useScroll = <T extends HTMLElement>(
  ref?: RefObject<T | null>,
): [ScrollState, { by: typeof window.scrollBy; to: typeof window.scrollTo }] => {
  const [state, setState] = useState<ScrollState>({ x: 0, y: 0, direction: 'none' });

  const scrollTo = useCallback(
    (...args) => {
      const target = ref?.current || window;

      if (typeof args[0] === 'object') {
        target.scrollTo(args[0]);
      }

      if (typeof args[0] === 'number' && typeof args[1] === 'number') {
        target.scrollTo(args[0], args[1]);
      }
    },
    [ref],
  ) as typeof window.scrollTo;

  const scrollBy = useCallback(
    (...args) => {
      const target = ref?.current || window;

      if (typeof args[0] === 'object') {
        target.scrollBy(args[0]);
      }

      if (typeof args[0] === 'number' && typeof args[1] === 'number') {
        target.scrollBy(args[0], args[1]);
      }
    },
    [ref],
  ) as typeof window.scrollTo;

  useLayoutEffect(() => {
    const target = ref?.current || window;

    const handleScroll = () => {
      const nextPosition = isWindow(target)
        ? { x: window.scrollX, y: window.scrollY }
        : { x: target.scrollLeft, y: target.scrollTop };

      setState((prev) => ({
        ...nextPosition,
        direction: nextPosition.y === prev.y ? 'none' : nextPosition.y > prev.y ? 'down' : 'up',
      }));
    };

    handleScroll();

    target.addEventListener('scroll', handleScroll);

    return () => target.removeEventListener('scroll', handleScroll);
  }, [ref]);

  return [state, { by: scrollBy, to: scrollTo }];
};
